import { ERestApiMethod } from "utils/api";
import ConversationResponseBased from "./ConversationResponseBased";

type TInput = {
  offerId: number | null;
  message: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  telephone?: string;
  displayCard?: boolean;
};

export default class StartConversationApiEndpoint extends ConversationResponseBased<TInput> {
  method = ERestApiMethod.POST;

  resolveUri(): string {
    return `/fe-api/feed/add`;
  }

  mapRequestData(data: TInput): any {
    return {
      email: data.email,
      first_name: data.firstName,
      last_name: data.lastName,
      phone: data.telephone,
      rent_id: data.offerId,
      msg: data.message,
      display_card: data.displayCard,
    };
  }
}
